export const RANKING = '/ranking-level/updateRankingLevel'
